import { useMemo, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ChangePassword({ token, currentUser, onDone }) {
  const [passwordActual, setPasswordActual] = useState('');
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const canSubmit = useMemo(() => {
    return (
      passwordActual.length > 0 &&
      nuevaPassword.length >= 6 &&
      !loading
    );
  }, [passwordActual, nuevaPassword, loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await fetch(`${API_URL}/usuarios/cambiar-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          password_actual: passwordActual,
          nueva_password: nuevaPassword,
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.message || 'No se pudo cambiar la contraseña');
      }
      setSuccess(data?.message || 'Contraseña actualizada');
      setTimeout(() => {
        onDone?.();
      }, 700);
    } catch (err) {
      setError(err?.message || 'Error inesperado');
    } finally {
      setLoading(false);
    }
  };

  const nombre = currentUser?.nombre_completo || currentUser?.nombre || 'Usuario';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background: '#f3f5f7',
      }}
    >
      <form className="form-container" onSubmit={handleSubmit}>
        <h2 style={{ marginTop: 0, marginBottom: 8, color: '#00928F' }}>
          Cambiar contraseña
        </h2>
        <p style={{ marginTop: 0, marginBottom: 18, color: '#666', fontSize: 14 }}>
          Hola {nombre}. Debes cambiar tu contraseña para continuar.
        </p>

        <label style={{ display: 'block', fontSize: 13, color: '#444' }}>
          Contraseña actual
        </label>
        <input
          className="form-input"
          type="password"
          value={passwordActual}
          onChange={(e) => setPasswordActual(e.target.value)}
        />

        <label style={{ display: 'block', marginTop: 10, fontSize: 13, color: '#444' }}>
          Nueva contraseña (mín. 6)
        </label>
        <input
          className="form-input"
          type="password"
          value={nuevaPassword}
          onChange={(e) => setNuevaPassword(e.target.value)}
        />

        {error && (
          <div
            style={{
              marginTop: 12,
              padding: 10,
              borderRadius: 6,
              background: '#fdecec',
              color: '#b00020',
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        {success && (
          <div
            style={{
              marginTop: 12,
              padding: 10,
              borderRadius: 6,
              background: '#ecf7ee',
              color: '#1f7a2e',
              fontSize: 13,
            }}
          >
            {success} (cerrando sesión...)
          </div>
        )}

        <button
          className="formButton"
          type="submit"
          disabled={!canSubmit}
          style={{ marginTop: 14, opacity: canSubmit ? 1 : 0.7 }}
        >
          {loading ? 'Actualizando...' : 'Actualizar'}
        </button>

        <button
          type="button"
          className="btn-secondary"
          onClick={() => onDone?.()}
          style={{ marginTop: 10, width: '100%' }}
        >
          Cancelar
        </button>
      </form>
    </div>
  );
}
